module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, _vm._l((_vm.categories), function(category) {
    return _c('my-category', {
      key: category.id,
      attrs: {
        "id": category.id,
        "default": category.default,
        "disabled": category.disabled,
        "label": category.label,
        "groups": category.groups
      },
      model: {
        value: (_vm.categoryStates[category.id]),
        callback: function($$v) {
          _vm.$set(_vm.categoryStates, category.id, $$v)
        },
        expression: "categoryStates[category.id]"
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-528b49f7","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/ui/components/navigations/Gnavi/GnaviInner.vue
// module id = 364
// module chunks = 1